import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "no";
    return window.localStorage.getItem("pendli-lang") || "no";
  });

  useEffect(() => {
    window.localStorage.setItem("pendli-lang", lang);
    document.documentElement.lang = lang === "no" ? "nb" : "en";
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    t: translations[lang],
    toggle: () => setLang((p) => (p === "no" ? "en" : "no")),
    setLang,
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
